import { callParent } from "./message.callParent";
import type { ParentInfoType } from "@widgets-connect/message/message.types";


let promise: Promise<ParentInfoType> | null = null;
export async function getParentInfo(): Promise<ParentInfoType> {
    if ((window as any).parentInfo) {
        return (window as any).parentInfo;
    }
    if (promise) {
        return promise;
    }
    promise = callParent('zmgGetParentInfo');
    (window as any).parentInfo = await promise;
    // check ancestorOrigins supported by browser
    const supportsAncestorOrigins = 'ancestorOrigins' in window.location;
    if (supportsAncestorOrigins) {
        const origins = window.location.ancestorOrigins; // this is cross origin parent page check
        const topOrigin = origins[origins.length - 1];
        if (topOrigin !== new URL((window as any).parentInfo.parentUrl).origin) {
            unexpectedOriginDetected();
            throw new Error("Parent URL is not the same as the top origin");
        }
    } else {
        const referrerOrigin = document.referrer ? new URL(document.referrer).origin : null;
        if (referrerOrigin !== new URL((window as any).parentInfo.parentUrl).origin) {
            unexpectedOriginDetected();
            throw new Error("Parent URL is not the same as the referrer origin");
        }
    }

    if (!(window as any).parentInfo.websiteId) {
        throw new Error("Website id not found");
    }
    if (!(window as any).parentInfo.dataLayerIframeId) {
        throw new Error("Data layer iframe id not found");
    }
    if (!(window as any).parentInfo.iframeId) {
        throw new Error("Iframe id not found");
    }
    if (!(window as any).parentInfo.parentUrl) {
        throw new Error("Parent URL not found");
    }
    return (window as any).parentInfo;
}


function unexpectedOriginDetected() {
    for (const element of document.body.children) {
        element.remove();
    }
    const modal = document.createElement('div');
    modal.id = 'unsafe-blocking-modal';
    modal.innerHTML = ` <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 999999;">
                            <div style="padding: 20px; border-radius: 10px;">
                                <h2 style="font-size: 24px; font-weight: bold;">Unexpected origin detected!</h2>
                                <p>Parent origin does not match the expected origin.</p>
                            </div>
                        </div>`;
    document.body.appendChild(modal);
    // show modal
    modal.style.display = 'block';
}